import { StoppageReasonResponseDto } from '@operations/app/api'
import { StoppageReasonStore } from '@operations/stores/StoppageReasonStore'
import { action, computed, makeObservable, observable } from 'mobx'

export class StoppageReasonViewStore {
  itemId?: number
  isDeleteOpen = false
  idToBeDeleted?: number

  constructor(private stoppageReasonStore: StoppageReasonStore) {
    makeObservable(this, {
      itemId: observable,
      isDeleteOpen: observable,
      setDeleteOpen: action,
      setItemToBeEdited: action,
      filteredItems: computed,
      dataToBeEdited: computed,
    })
  }
  public get dataToBeEdited(): StoppageReasonResponseDto | undefined {
    return this.itemId ? this.stoppageReasonStore.items.find(i => i.id === this.itemId) : undefined
  }

  public get filteredItems() {
    return this.stoppageReasonStore.items
  }

  setItemToBeEdited = (itemId?: number) => {
    this.itemId = itemId
  }

  setDeleteOpen = (isOpen: boolean, id?: number) => {
    this.isDeleteOpen = isOpen
    this.itemId = id
  }
}
